import seoConfig from "@/constants/seo.json";

const interpolate = (str, variables) => {
  if (typeof str !== "string") return str;
  return str.replace(/{(\w+)}/g, (match, key) => {
    return variables[key] !== undefined ? variables[key] : match;
  });
};

const processSEO = (item, variables) => {
  if (typeof item === "string") {
    return interpolate(item, variables);
  }
  if (Array.isArray(item)) {
    return item.map((i) => processSEO(i, variables));
  }
  if (typeof item === "object" && item !== null) {
    const processed = {};
    for (const key in item) {
      processed[key] = processSEO(item[key], variables);
    }
    return processed;
  }
  return item;
};

export const getSEO = (pageKey, customVariables = {}) => {
  const global = seoConfig.global || {};
  const pageConfig = seoConfig[pageKey] || {};
  const variables = {
    brand: global.brand || "Tykkit",
    city: customVariables.city || global.defaultCity || "Ahmedabad",
    separator: global.separator || " | ",
    year: new Date().getFullYear().toString(),
    ...customVariables,
  };

  if (variables.city === "{city}") {
    variables.city = "Ahmedabad";
  }

  return processSEO(pageConfig, variables);
};
